export default __webpack_public_path__ + "static/media/Cara_e_Elio.c5e2c499.jpg";